import { createReducer, on } from '@ngrx/store';
import * as fromTokensActions from '../actions/tokens.actions';

export const featureKey = 'tokens';

export interface State {
    tokens: {
        data: Array<any>,
        isLoaded: Boolean
    },
    tokensForSale: {
        data: Array<any>,
        isLoaded: Boolean
    },
    tokenCart: {
        tokens: Array<any>,
        quantity: number,
        points: number
    },
    tokenOrderHistory: {
        data: Array<any>,
        isLoaded: Boolean
    },
}

export const initialState: State = {
    tokens: {
        data: [],
        isLoaded: false
    },
    tokensForSale: {
        data: [],
        isLoaded: false
    },
    tokenCart: {
        tokens: [],
        quantity: 0,
        points: 0
    },
    tokenOrderHistory: {
        data: [],
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromTokensActions.getUserTokensSuccess, (state: State, props: any) => ({
        ...state,
        tokens: {data: props.data, isLoaded: true}
    })),
    on(fromTokensActions.getTokensForSaleSuccess, (state: State, props: any) => ({
        ...state,
        tokensForSale: {data: props.data, isLoaded: true}
    })),

    /** Cart */
    on(fromTokensActions.updateTokenCart, (state: State, props: any) => ({
        ...state,
        tokenCart: props.data
    })),
    on(fromTokensActions.clearTokenCart, (state: State) => ({
        ...state,
        tokenCart: {
            tokens: [],
            quantity: 0,
            points: 0
        }
    })),

    //Token order history
    on(fromTokensActions.getTokensOrderHistorySuccess, (state : State, props : any)=> ({
        ...state,
        tokenOrderHistory : {
            data : props.data,
            isLoaded : true
        }
    }))
);